<template>
  <div class="jobs-create" v-loading="loading">
    <el-form>
      <el-form-item :label="`Название поля`">
        <el-input v-model="form.name"/>
      </el-form-item>

      <filter-select
        v-model="form.type"
        label="Вид"
        @input="changeType"
        :options="list"
      />

      <el-checkbox
        v-if="form.type.value === 'select' || form.type.value.includes( 'multiple') || form.type.value.includes('materials') || form.type.value.includes('constructions')  || form.type.value ===  'nomenclature'"
        v-model="form.isEditable" style="margin-top: 10px; margin-bottom: 10px">Создание списка в отчете
      </el-checkbox>

      <div style="width: 100%;">
        <docs-input-modal v-if="form.type.value ===  'nomenclature'" :form="form" :type="form.type.value"
                          @edit-zone="editZone"
                          v-model="form.options"/>
      </div>

      <div style="display: flex; align-items: center"
           v-if="form.type.value.includes('materials') || form.type.value.includes('constructions') || form.type.value.includes('multiple')">
        <el-checkbox
          v-model="form.isZone" style="margin-top: 10px; margin-bottom: 10px">По зонам работ
        </el-checkbox>
        <zone-input-modal :form="form" v-if="form.isZone" :type="form.type.value" @edit-zone="editZone"
                          v-model="form.options"/>
      </div>

      <div style="display: flex; align-items: center"
           v-if="form.type.value.includes('materials') || form.type.value.includes('constructions') || form.type.value ===  'nomenclature'">
        <el-checkbox
          v-model="form.withoutPlan" style="margin-top: 10px; margin-bottom: 10px">Без плана
        </el-checkbox>
      </div>

      <div style="display: flex; align-items: center"
           v-if="form.type.value.includes('materials') || form.type.value.includes('constructions') || form.type.value.includes('multiple') || form.type.value ===  'nomenclature'">
        <el-checkbox
          v-model="form.isDetail" style="margin-top: 10px; margin-bottom: 10px">Примечание
        </el-checkbox>
      </div>

      <div style="display: flex; justify-content: flex-end; margin-top: 20px">
        <ImportFromExcel
          :notActive="form.notActive"
          @update="update"
                         :type="form.type.value"
                         v-if="form.type.value.includes('multiple') || form.type.value === 'select' || form.type.value.includes('materials') || form.type.value.includes('constructions') || form.type.value ===  'nomenclature'"/>
      </div>
      <div v-if="form.type.value === 'calc'">
        <filter-select
          v-model="form.options[0]"
          label="Поле 1"
          :options="optionsInput"
        />


        <filter-select
          v-model="form.operation"
          label="Арифметическое действие"
          :options="optionsOperations"
        />

        <filter-select
          v-model="form.options[1]"
          label="Поле 2"
          :options="optionsInput"
        />
      </div>

      <div
        v-if="form.type.value === 'select' || form.type.value.includes('multiple') || form.type.value.includes('materials') || form.type.value.includes('constructions')  || form.type.value ===  'nomenclature'">
        <el-checkbox style="position: absolute; margin-left: 56px; margin-top: 10px"
                     v-if="form.type.value ===  'nomenclature'" v-model="form.notActive[1]">Активное
        </el-checkbox>
        <el-form-item :label="`Поле 1`"
                      v-if="!(form.type.value.includes('materials') || form.type.value.includes('constructions')  || form.type.value ===  'nomenclature')">
          <el-input v-model="form.labels[1]"/>
        </el-form-item>
        <unit-select
          v-else
          placeholder="Ед. изм."
          v-model="form.defaultFields[1]"
          label="Поле 1"
        />
        <div @click="inVolume(1)" v-if="form.type.value.includes('multiple')" class="checkbox-container">
          <el-checkbox v-model="form.volumeId[1]">В объем</el-checkbox>
        </div>

        <el-form-item :label="`Поле 2`">
          <el-input v-model="form.labels[2]"
                    :disabled="form.type.value.includes('materials') || form.type.value.includes('constructions')  || form.type.value ===  'nomenclature'"/>
        </el-form-item>
        <div @click="inVolume(2)" v-if="form.type.value.includes('multiple')" class="checkbox-container">
          <el-checkbox v-model="form.volumeId[2]">В объем</el-checkbox>
        </div>

        <el-checkbox v-if="form.type.value ===  'nomenclature'"
                     style="position: absolute; margin-left: 56px; margin-top: 10px" v-model="form.notActive[2]">
          Активное
        </el-checkbox>
        <el-form-item :label="`Поле 3`"
                      v-if="!form.type.value.includes('constructions') && form.type.value !==  'nomenclature' ">
          <el-input v-model="form.labels[3]"/>
        </el-form-item>
        <unit-select
          v-else
          placeholder="Ед. изм. 2"
          v-model="form.defaultFields[3]"
          label="Поле 3"
        />
        <div @click="inVolume(3)" v-if="form.type.value.includes('multiple')" class="checkbox-container">
          <el-checkbox v-model="form.volumeId[3]">В объем</el-checkbox>
        </div>

        <el-form-item :label="`Поле 4`">
          <el-input v-model="form.labels[4]"
                    :disabled="form.type.value.includes('constructions') || form.type.value ===  'nomenclature'"/>
        </el-form-item>
        <div @click="inVolume(4)" v-if="form.type.value.includes('multiple')" class="checkbox-container">
          <el-checkbox v-model="form.volumeId[4]">В объем</el-checkbox>
        </div>

        <el-form-item :label="`Поле 5`">
          <el-input v-model="form.labels[5]"/>
        </el-form-item>
        <div @click="inVolume(5)" v-if="form.type.value.includes('multiple') || form.type.value ===  'nomenclature'"
             class="checkbox-container">
          <el-checkbox v-model="form.volumeId[5]">В объем</el-checkbox>
        </div>

        <template v-if="form.type.value ===  'nomenclature'">
          <el-form-item :label="`Поле 6`">
            <el-input v-model="form.labels[6]"/>
          </el-form-item>
          <div @click="inVolume(6)" class="checkbox-container">
            <el-checkbox v-model="form.volumeId[6]">В объем</el-checkbox>
          </div>

          <el-form-item :label="`Поле 7`">
            <el-input v-model="form.labels[7]"/>
          </el-form-item>
          <div @click="inVolume(7)" class="checkbox-container">
            <el-checkbox v-model="form.volumeId[7]">В объем</el-checkbox>
          </div>

          <el-form-item :label="`Поле 8`">
            <el-input v-model="form.labels[8]"/>
          </el-form-item>
          <div @click="inVolume(8)" class="checkbox-container">
            <el-checkbox v-model="form.volumeId[8]">В объем</el-checkbox>
          </div>

          <el-form-item :label="`Поле 9`">
            <el-input v-model="form.labels[9]"/>
          </el-form-item>
          <div @click="inVolume(9)" class="checkbox-container">
            <el-checkbox v-model="form.volumeId[9]">В объем</el-checkbox>
          </div>

          <el-form-item :label="`Поле 10`">
            <el-input v-model="form.labels[10]"/>
          </el-form-item>
          <div @click="inVolume(10)" class="checkbox-container">
            <el-checkbox v-model="form.volumeId[10]">В объем</el-checkbox>
          </div>
        </template>


        <option-list v-if="form.type.value !== 'nomenclature'" @change="changeIndex" :form="form"
                     v-model="form.options" :type="form.type.value"/>
      </div>

      <div class="jobs-create__buttons">
        <el-button @click="close" v-if="!$route.params.id">Отмена</el-button>
        <el-button v-else type="danger" @click="deleteObject">Удалить</el-button>

        <el-button v-if="!$route.params.id" type="primary" @click="save">Сохранить</el-button>
        <el-button v-else type="primary" @click="edit">Сохранить</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import firebase from 'firebase';

import FilterSelect from "../../../components/FilterSelect";
// getUnits
import draggable from 'vuedraggable';
import ImportFromExcel from "./ImportFromExcel";
import ZoneInputModal from "./Zone/ZoneInputModal";
import UnitSelect from "../components/unitSelect";
import AddOption from "./AddOption";
import OptionList from "./OptionList";
import DocsInputModal from "./Docs/DocsInputModal";
import {addOptionsInputs} from "../../../firestore/inputs";
import {orderBy} from "lodash";


export default {
  name: 'Create',
  components: {
    DocsInputModal,
    OptionList, AddOption, UnitSelect, ZoneInputModal, ImportFromExcel, FilterSelect, draggable
  },
  data() {
    return {
      dialogVisible: false,
      optionEdit: {},
      loading: false,
      originalOptions: false,
      savedValue: [],
      checked: true,
      optionsInput: [
        {
          label: 'Факт объемы',
          value: 'fact',
        },
      ],
      optionsUnit: [],
      optionsOperations: [
        {
          label: '-',
          value: '-',
        },
        {
          label: '+',
          value: '+',
        },
        {
          label: '*',
          value: '*',
        },
        {
          label: '/',
          value: '/',
        },
      ],
      list: [
        {
          label: 'Текст',
          value: 'text',
        },
        {
          label: 'Список',
          value: 'select',
        },
        {
          label: 'Множественный выбор',
          value: 'multiple',
        },
        {
          label: 'Множественный выбор L',
          value: 'multipleL',
        },
        {
          label: 'Дата',
          value: 'date',
        },
        {
          label: 'Число',
          value: 'number',
        },
        {
          label: 'Расчетное поле',
          value: 'calc',
        },
        {
          label: 'Материалы',
          value: 'materials',
        },
        {
          label: 'Конструкции',
          value: 'constructions',
        },
        {
          label: 'Конструкции L',
          value: 'constructionsL',
        },
        {
          label: 'Материалы L',
          value: 'materialsL',
        },
        {
          label: 'Номенклатура',
          value: 'nomenclature',
        },
      ],
      createJoinInternal: false,
      form: {
        notActive: {
          1: false,
          2: false,
        },
        name: '',
        type: {
          label: 'Текст',
          value: 'text',
          notActive: false
        },
        isDetail: false,

        defaultFields: {
          1: null,
          2: null,
          3: null,
          4: null,
          5: null,
        },
        isZone: false,
        isEditable: false,
        withoutPlan: false,
        operation: null,
        dirs: [],
        volumeId: {
          1: false,
          2: false,
          3: false,
          4: false,
          5: false
        },
        options: [],
        labels: {
          1: '',
          2: '',
          3: '',
          4: '',
          5: ''
        }
      },
    };
  },

  async mounted() {
    const inputs = await myFirestore
      .collection('projects')
      .doc(this.$store.state.project.id)
      .collection('inputs')
      .get()


    const result = []
    inputs.forEach((d) => {
      const data = d.data()

      if (!data.type) {
        data.type = this.form.type
      }

      if (data.type.value === 'number') {
        result.push({
          label: d.data().name,
          value: d.id
        })
      }
    })


    this.optionsInput = [
      ...this.optionsInput, ...result
    ]

    if (this.$route.params.id) {
      myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('inputs')
        .doc(this.$route.params.id).get().then(async (response) => {
        const data = response.data();
        if (!data.type) {
          data.type = this.form.type
        }

        this.form = {
          ...this.form,
          ...data,
          id: this.$route.params.id,
          type: this.list.find((d) => data.type.value === d.value)
        };
        if (this.form.type && (this.form.type.value === 'nomenclature' || this.form.type.value.includes('L'))) {
          const resp = await myFirestore
            .collection('projects')
            .doc(this.$store.state.project.id)
            .collection('inputs')
            .doc(this.$route.params.id)
            .collection('optionsList')
            .orderBy('index', 'asc')
            .limit(100)
            .get()


          const result = []
          console.log(result, result.length)
          resp.forEach((d) => {
            result.push({
              ...d.data(),
              isCreate: true,
            })
          })

          this.form.options = orderBy([...result], 'index', 'asc')
        }
      });
    }
  },

  watch: {
    'form.options'() {

    }
  },
  methods: {
    inVolume(id) {
      if (this.form.volumeId[id]) {
        setTimeout(() => {
          this.form.volumeId[id] = false
        }, 100)
      }
      if (this.form.type && this.form.type.value === 'nomenclature') {
        this.form.volumeId = {
          1: false,
          2: false,
          3: false,
          4: false,
          5: false,
          6: false,
          7: false,
          8: false,
          9: false,
          10: false,
        }
      } else {
        this.form.volumeId = {
          1: false,
          2: false,
          3: false,
          4: false,
          5: false,
        }
      }
    },
    changeIndex() {
      if (!this.form.type.label.includes('L') && this.form.type.value !== 'nomenclature') {
        myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('inputs')
          .doc(this.$route.params.id).update(
          {...this.form}
        )
      } else {
        addOptionsInputs(this.$store.state.project.id, this.$route.params.id, this.form.options.filter(({zoneId}) => !zoneId).map((t, key) => {
          return {
            ...t,
            index: key
          }
        }))
      }
    },
    editZone() {
      //   this.form.options.push({
      //     label: '',
      //     value: '',
      //     uid: uuidv4(),
      //     details: {
      //       1: '',
      //       2: '',
      //       3: '',
      //       4: '',
      //       5: ''
      //     },
      //   })
      // this.dialogVisible = true;
      // this.optionEdit = this.form.options[this.form.options.length - 1];
    },
    changeType() {
      this.form.options = []
      this.form.labels = {
        1: '',
        2: '',
        3: '',
        4: '',
        5: ''
      }

      if (this.form.type.value.includes('materials')) {
        this.form.options = []
        this.form.labels = {
          1: 'Ед. изм.',
          2: 'План',
          3: '',
          4: '',
          5: ''
        }
      }

      if (this.form.type.value === 'nomenclature') {
        this.form.labels = {
          1: 'Ед. изм.',
          2: 'План',
          3: 'Ед. изм. 2',
          4: 'План на ед.',
          5: '',
          6: '',
          7: '',
          8: '',
          9: '',
          10: '',
        }
      }


      if (this.form.type.value.includes('constructions')) {
        this.form.options = []
        this.form.labels = {
          1: 'Ед. изм.',
          2: 'План',
          3: 'Ед. изм. 2',
          4: 'План на ед.',
          5: ''
        }
      }
    },
    update() {
      if (this.$route.params.id) {
        myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('inputs')
          .doc(this.$route.params.id).get().then((response) => {
          const data = response.data();
          this.form = {
            ...this.form,
            ...data,
          };
        });
      }
    },
    deleteObject() {
      this.$confirm('Вы действительно хотите удалить?', 'Подтверждение', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(() => {
        myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('inputs')
          .doc(this.$route.params.id).delete()
          .then((data) => {
            this.$emit('update');
            this.$notify({
              offset: 60,

              title: 'Успешно!',
              message: 'удалено',
              type: 'success',
            });
          });
      });
    },
    close() {
      this.$router.go(-1);
    },
    async edit() {
      console.log(this.form, 'this.form')
      await this.changeIndex()

      myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('inputs').doc(this.$route.params.id)
        .update({
          ...this.form,
          options: this.form.type.value === 'nomenclature' && this.form.type.value.includes('L') ? null : this.form.options,
        }).then(async (add) => {
        if (this.form.type && (this.form.type.value === 'nomenclature' || this.form.type.value.includes('L'))) {
          await addOptionsInputs(this.$store.state.project.id, this.$route.params.id, this.form.options.filter(({zoneId}) => !zoneId).map((t, key) => {
            return {
              ...t,
              index: t.isCreate ? key : t.index
            }
          }))
        }
        this.$notify({
          offset: 60,

          title: 'Успешно!',
          message: 'Отредактировано',
          type: 'success',
        });
        setTimeout(() => this.$router.go(-1), 1000);
      }).catch((error) => {
        console.error(error);
        this.$notify({
          offset: 60,
          title: 'Упс... ',
          message: 'Произошла ошибка повторите позже',
          type: 'error',
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    async save() {
      this.loading = true;

      const inputs_r = await myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('inputs')
        .orderBy("index", 'desc').limit(1)
        .get();

      let inputs = {
        index: 0
      };

      inputs_r.forEach((subDoc) => {
        inputs = subDoc.data();
      });

      // myFirestore
      //   .collection('projects')
      //   .doc(this.$store.state.project.id)
      //   .collection('inputs')
      //   .doc()

      myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('inputs')
        .add({
          ...this.form,
          options: (this.form.type.value === 'nomenclature' || this.form.type.value.includes('L')) ? null : this.form.options,
          index: inputs.index + 1,
        }).then(async (add) => {
        if (this.form.type.value === 'nomenclature' || this.form.type.value.includes('L')) {
          await addOptionsInputs(this.$store.state.project.id, add.id, this.form.options.map((t, key) => {
            return {
              ...t,
              index: key
            }
          }))
        }

        this.$notify({
          offset: 60,
          title: 'Успешно!',
          message: 'Добавлено',
          type: 'success',
        });
        this.form = {
          name: '',
        };
        setTimeout(() => {
          this.$router.go(-1);
        }, 1000);
      }).catch((error) => {
        this.$notify({
          offset: 60,
          title: 'Упс... ',
          message: 'Произошла ошибка повторите позже',
          type: 'error',
        });
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.jobs-create {
  max-width: 382px;
  width: calc(100% - 40px);
  margin: 42px auto;
  padding-bottom: 128px;

  > > > .el-form-item {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    margin-bottom: 0px;
    justify-content: flex-start;

    .el-form-item__content {
      display: flex;
      justify-content: flex-start;
      width: 100%;
    }

    .el-form-item__label {
      padding: 0;
    }
  }

  &__buttons {
    margin-top: 28px;
    justify-content: space-between;
    width: 100%;
    flex: 1;
    display: flex;

    &:before {
    }

    &:after {
    }
  }

  .input-line-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
    flex: 1;
  }

  .select-type {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }
}

.joint {
  box-shadow: 0px 0px 8px 0px #ccc;
  background: #f7f7f7;
  padding: 10px 20px;
  border-radius: 5px;
}

.in-line {
  display: flex;
}

.jobs-create__buttons {
  position: fixed;
  bottom: 0;
  max-width: 382px;
  width: calc(100% - 40px);
  background: #fff;
  border-top: 1px solid #ccc;
  padding: 10px;
}

.joint-li {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 20px;
}

.li-header {
  display: flex;
  justify-content: space-between;
  flex: 1;
  width: 100%;
}

.link-block {
  font-size: 14px;
  font-weight: bold;
  color: #409EFF;
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
  position: relative;
  margin-bottom: -26px;
}

.dialog-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.checkbox-container {
  display: flex;
  justify-content: flex-start;
  margin-top: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Inputs/Create.vue